import axios from "axios";

export const getViewCustomer = async () => {
  return await axios.get(`${process.env.REACT_APP_HOST}/customers`);
};
export const nextCustomerId = async () => {
  return await axios.get(
    `${process.env.REACT_APP_HOST}/quotation/nextCustomerId`
  );
};

export const getViewStudent = async () => {
  return await axios.get(
    `${process.env.REACT_APP_HOST}/students/getStudent`
  );
};

export const fetchDataManagement = async () => {
  return await axios.get(
    `${process.env.REACT_APP_HOST}/sales/getSales`
  );
};
